var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"normal-render"},[(_vm.answers.useNormalText)?_c('normalText',{attrs:{"answers":_vm.answers}}):_c('zhenxuanguBox',{attrs:{"answers":_vm.answers,"session":_vm.session}}),(_vm.needGuide && _vm.showGuide)?_c('GuideQuestion',{attrs:{"session":_vm.session}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }